<mat-card appearance="outlined" class="card">
  <div class="flex-row">
    <div style="flex: 1 1 15%">
      <button
        matButton="elevated"
        color="primary"
        (click)="loadDocumentsFromServer()"
        class="app-panel-button"
        i18n
        [disabled]="libraryLoaded === true"
      >
        Load library from server
      </button>
      <button
        matButton="elevated"
        (click)="clearRefresh()"
        class="app-panel-button"
        i18n
        [disabled]="libraryLoaded === null"
      >
        Clear and Refresh
      </button>
    </div>

    @if (libraryLoaded) {
    <div style="flex: 1 1 35%">
      <app-library-documents-tree [libraryType]="LibraryT.PUBLIC"
       />
    </div>
    <div style="flex: 1 1 35%">
      <app-library-documents-tree [libraryType]="LibraryT.PERSONAL"
       />
    </div>
    } @else {
    <div class="fxflex-1-0" style="flex-basis: 65%">
      <h2 i18n>Library not loaded</h2>
    </div>
    }
  </div>
</mat-card>
